var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1036_9220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 3.75C38.7655 3.75 44.25 9.23451 44.25 16C44.25 22.7655 38.7655 28.25 32 28.25C25.2345 28.25 19.75 22.7655 19.75 16C19.75 9.23451 25.2345 3.75 32 3.75Z",
    stroke: "url(#paint0_linear_1036_9220)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 11.5H28.5C28.2348 11.5 27.9804 11.6054 27.7929 11.7929C27.6054 11.9804 27.5 12.2348 27.5 12.5V19.5C27.5 19.7652 27.6054 20.0196 27.7929 20.2071C27.9804 20.3946 28.2348 20.5 28.5 20.5H35.5C35.7652 20.5 36.0196 20.3946 36.2071 20.2071C36.3946 20.0196 36.5 19.7652 36.5 19.5V16",
    stroke: "url(#paint1_linear_1036_9220)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1875 11.3126C35.3865 11.1137 35.6562 11.002 35.9375 11.002C36.2189 11.002 36.4886 11.1137 36.6875 11.3126C36.8865 11.5115 36.9982 11.7813 36.9982 12.0626C36.9982 12.3439 36.8865 12.6137 36.6875 12.8126L32.181 17.3196C32.0623 17.4382 31.9157 17.5251 31.7545 17.5721L30.318 17.9921C30.275 18.0047 30.2294 18.0054 30.186 17.9943C30.1426 17.9832 30.103 17.9606 30.0713 17.9289C30.0396 17.8972 30.017 17.8576 30.0059 17.8142C29.9947 17.7707 29.9955 17.7251 30.008 17.6821L30.428 16.2456C30.4753 16.0846 30.5623 15.9381 30.681 15.8196L35.1875 11.3126Z",
    stroke: "url(#paint2_linear_1036_9220)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1036_9220",
    x: 0.605101,
    y: 0.350849,
    width: 62.7898,
    height: 62.7898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.72372,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1036_9220"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15.7457
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.8093
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1036_9220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6.2983,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1036_9220"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.2983
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.72372
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1036_9220",
    result: "effect2_dropShadow_1036_9220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1036_9220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1036_9220",
    x1: 32,
    y1: 4,
    x2: 32,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1036_9220",
    x1: 32,
    y1: 11.5,
    x2: 32,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1036_9220",
    x1: 33.4981,
    y1: 11.002,
    x2: 33.4981,
    y2: 18.0021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompose);
export default __webpack_public_path__ + "static/media/compose.7d56165bc4e323dd5d3bd81b5d68a765.svg";
export { ForwardRef as ReactComponent };